import { CanMatchFn } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Matches the v2 community routes only when environment.enableNewCommunityPage is true.
 * When it returns false the router falls through to the classic routes.
 */
export const communityVersionGuard: CanMatchFn = () => (environment as any).enableNewCommunityPage === true;
